import React from 'react';
import '../CSS/AboutInfo.css'

import vachnalay from '../Images/vachnalay.png';
import sanman from '../Images/Sanman.png';




 
const AboutInfo = () =>{




return (


   



<div className='About-info'>
  <div className='About-heading'>
  <h3> <span className='orange'>आमच्या</span> बद्दल</h3>
  <p>भारतातील पाहिलं माझ कवितांचं गाव जकातवाडी </p>
  </div>
  <div className='About-information1'>
    <img src={vachnalay} className='vachnalay'></img>
    <p className='vachnalay-info'>कृष्णाकाठ ज्ञान साधनेची मोठी परंपरा निर्माण झाली विश्वकोषत्याच्याच काही अंतरावर भारतातील पहिलं पुस्तकाचं गाव याच्याच थोड्या अंतरावर निसर्गाच वरदान लाभलेल्याआणिअजिंक्यतारा किल्ल्याच्या कुशीत असलेले खिंडीतील गणपती चे कायम आशिष असणारे जगातील पहिलं कवितांच गाव’जकातवाडी. यागावात पूर्वी सातारा येथे जाण्यासाठी जकात घेतली जायची यावरून या गावास जकातवाडी हे पडले असल्याच इतिहास आहे.या गावात चैत्र पौर्णिमेला गावाची यात्रा असते.या गावात वाचन संस्कृती रुजावी तिचा विकास व्हावा,वाचाल तर वाचाल,गाव तेथे ग्रंथालय या विचाराने २६ ऑक्टोबर१९९२ साली दीपावली पाडव्याच्या दिवशी विद्यावर्धिनी सार्वजनिक ग्राम वाचनालय सुरु करण्यात आले त्याचा परिणाम म्हणून गावात वाचन संस्कृती रुजू लागली तेव्हा पासून वाचनासाठी अशी साधन गावात उपलब्ध झाली ती वाचनालयाचे माध्यमातून. </p>
  </div>

  <div className='About-information2'>
    <p className='sanman-info'>शिक्षण,कृषि,साहित्य,सहकार,उद्योग,सांस्कृतिक कार्यअशा विविध क्षेत्रा मध्ये कर्तृत्वाची शिखरे पादाक्रांत करणारा सातारा हा क्रांतिकारकांचा जिल्हा म्हणून प्रसिद्ध.विविध क्षेत्रामध्ये स्वत:चे एक वेगळे स्थान निर्माण करणारा जिल्हा इतिहासाच्या पावुलखुणांबरोबर जैवविविधतेने नटलेल्या,साहित्यिक व ऐतिहासिक मोलाचा वाटा जतन करणाऱ्या इथल्या मातीत सेनादलात मर्दमुखी गाजवणाऱ्या शूर शिलेदारांचा जिल्हा,इथल्या यात्रा,जत्रा,सन समारंभ,ग्रंथमहोत्सव आणि उत्सवांची वैभवशाली परंपरा सांभाळत इथे घडत आहेत समाज मन. सातारा एक सृजनात्मक वारसा लाभलेला जिल्हा आहे. इतिहासकार,साहित्यिक,पत्रकार,कवी,कलाकार जन्मास आले.</p>
    <img src={sanman} className='sanman'></img>
    </div>
</div>













)



};

export default AboutInfo;